<igx-card class="igx-card--outlined2" style="height: 100%;">
  <igx-card-header>
    <div style="width: 100%; display: flex; align-items: center; justify-content: center; padding-bottom: 1rem">
      <igx-select [(ngModel)]="selected" style="width: 200px; padding-right: 1rem;">
        <label igxLabel>{{ 'GRIDS.COMPARTIR_PPTO.COL_NIVEL_ACCESO' | translate }}</label>
        @for (nivel of nivelAccesso; track nivel) {
          <igx-select-item [value]="nivel">
            {{ nivel }}
          </igx-select-item>
        }
      </igx-select>
      <button igxButton="contained" igxRipple (buttonClick)="asignarPermiso()">
        {{ 'BOTONES.ASIGNAR' | translate }}
      </button>
      <igx-date-picker #dateFechaVigencia [locale]="localGrid" todayButtonLabel="{{ 'MENSAJES.GRALS.HOY' | translate }}"
                       cancelButtonLabel="{{ 'MENSAJES.GRALS.CANCELAR' | translate }}" mode="dialog"
                       style="width: 230px; padding-left: 1rem; padding-right: 1rem;"
                       (closed)="obtenerDias($event)">
        <label igxLabel>{{ 'GRIDS.COMPARTIR_PPTO.COL_FECHA_VIGENCIA' | translate }}</label>
        <igx-picker-clear igxSuffix></igx-picker-clear>
      </igx-date-picker>
      <igx-input-group>
        <input #diasCalcular igxInput id="dias" name="dias" type="number"
               (change)="calcularVigencia(diasCalcular.valueAsNumber)"
               [igxTextSelection]="true"/>
        <label igxLabel for="dias">{{ 'MENSAJES.GRALS.DIAS' | translate }}:</label>
      </igx-input-group>
      <button igxButton="contained" igxRipple (buttonClick)="asignarVigencia()" style="margin-left: 1rem">
        {{ 'BOTONES.ASIGNAR' | translate }}
      </button>
    </div>
    <igx-input-group style="width: 100%; padding-bottom: 1rem">
      <label igxLabel>{{ 'MENSAJES.GRALS.LISTA_CORREOS' | translate }}</label>
      <textarea #textCorreos id="textCorreos" igxInput name="correos" class="textArea" [igxTextSelection]="true" [igxFocus]="true"
                (keydown)="stopPropagationPegado($event)"></textarea>
      <igx-suffix>
        <button igxButton="contained" igxRipple (buttonClick)="agregarCorreos(textCorreos)"
                [disabled]="textCorreos.value.length < 1">
          {{ 'BOTONES.AGREGAR' | translate }}
        </button>
      </igx-suffix>
    </igx-input-group>
  </igx-card-header>
  <igx-card-content class="igx-card-content2">
    <div class="content-wrap" igxLayout igxLayoutReverse="true">
      <igx-nav-drawer #drawer [pin]="true" [isOpen]="true" [pinThreshold]="0" [disableAnimation]="true"
                      width="385px">
        <ng-template igxDrawer>
            <span igxDrawerItem [isHeader]="true">
              <button igxButton="contained" igxRipple (buttonClick)="obtenerCorreosOrganizacion()" style="width: 100%">
                {{ 'BOTONES.OBTENER' | translate }}
              </button>
            </span>
          <igx-grid #gridUsuariosOrg [width]="'100%'" [height]="'calc(100% - 88px)'" [locale]="localGrid"
                    [moving]="true"
                    [sortingOptions]="sortingOptions" [allowFiltering]="true" [filterMode]="'excelStyleFilter'"
                    [showGroupArea]="true" [rowSelection]="rowSelectionMultiple"
                    [rowEditable]="false" [primaryKey]="'emailusuario'">
            <igx-grid-toolbar>
              <igx-grid-toolbar-title>
                <app-filtro-general #filtroGeneralUsuOrg
                                    descripcionLabel="{{ 'MENSAJES.GRALS.ETIQUETA_FILTRO_GRAL' | translate}}"
                                    (enterPalabra)="filterInputUsuOrg($event)"
                                    (limpiarPalabras)="clearInputUsuOrg()"></app-filtro-general>
              </igx-grid-toolbar-title>
              <igx-grid-toolbar-actions>
                <app-mas-opciones-grid #masOpcionesUsuOrg [arrayDatosAVer]="[3, 6]"
                                       (opcionSeleccionada)="onSelectionDropDown($event, true)"/>
              </igx-grid-toolbar-actions>
            </igx-grid-toolbar>
            <ng-template igxSortHeaderIcon>
              <igx-icon>north</igx-icon>
            </ng-template>
            <ng-template igxSortAscendingHeaderIcon>
              <igx-icon>north</igx-icon>
            </ng-template>
            <ng-template igxSortDescendingHeaderIcon>
              <igx-icon>south</igx-icon>
            </ng-template>
            <ng-template igxExcelStyleHeaderIcon>
              <igx-icon>filter_alt</igx-icon>
            </ng-template>
            <igx-column field="emailusuario" header="{{'GRIDS.CAMBIO_PROPIETARIO.COL_EMAIL' | translate}}"
                        title="{{'GRIDS.CAMBIO_PROPIETARIO.COL_EMAIL' | translate}}" width="320px" [dataType]="'string'"
                        [sortable]="true" [resizable]="true" [editable]="false" [hasSummary]="true"
                        [summaries]="'filasSummary' | summaryPipeNeo"></igx-column>
            <igx-column field="nombreUsuario" header="{{'GRIDS.CAMBIO_PROPIETARIO.COL_NOMBRE_USU' | translate}}"
                        title="{{'GRIDS.CAMBIO_PROPIETARIO.COL_NOMBRE_USU' | translate}}" width="350px"
                        [dataType]="'string'" [sortable]="true" [resizable]="true" [editable]="false"></igx-column>
            <!--            <igx-column field="fechaVigencia" header="{{'GRIDS.CAMBIO_PROPIETARIO.COL_FECHA_VIG' | translate}}" title="{{'GRIDS.CAMBIO_PROPIETARIO.COL_FECHA_VIG' | translate}}" width="180px" [dataType]="'date'" [sortable]="true" [resizable]="true" [editable]="false" [pipeArgs]="formatColFechaDDMMYYYY"></igx-column>-->
          </igx-grid>
          <div igxDialogActions>
            <button igxButton="contained" (buttonClick)="addMiListaCompartidos()"
                    style="width: 100%">{{ 'BOTONES.ADD_LISTA_CORREOS' | translate }}
            </button>
          </div>
        </ng-template>
      </igx-nav-drawer>
      <igx-grid #gridCompartirPresupuesto [width]="'100%'" [height]="'100%'" [locale]="localGrid" [moving]="true"
                [rowSelection]="rowSelectionMultiple"
                [rowEditable]="false" [allowFiltering]="true" [filterMode]="'excelStyleFilter'"
                (columnInit)="onColumnInit($event)" paste-handler-neodata
                (onDataProcessed)="datosPegadosDesdeExcel($event)"
                [batchEditing]="true" [primaryKey]="'IdPresupuestoXUsuario'" (rowEditEnter)="rowEditEnter($event)"
                (rowEditExit)="rowEditExit()"
                (cellEditEnter)="cellEditEnter($event)">
        <!--       (rowEdit)="validarUsuarioCompartido($event)" (rowEditDone)="addUpdateUsuarioCompartido($event)"-->
        <igx-grid-toolbar>
          <igx-grid-toolbar-title>
            <app-filtro-general #filtroGeneral descripcionLabel="{{ 'MENSAJES.GRALS.ETIQUETA_FILTRO_GRAL' | translate}}"
                                (enterPalabra)="filterInput($event)"
                                (limpiarPalabras)="clearInput()"></app-filtro-general>
          </igx-grid-toolbar-title>
          <igx-grid-toolbar-actions>
            <button title="{{ 'TOOLTIPS.DESHACER' | translate}}" igxButton="contained" igxRipple
                    [disabled]="!gridCompartirPresupuesto.transactions.canUndo" (buttonClick)="undo()">
              <igx-icon>undo</igx-icon>
            </button>
            <button title="{{ 'TOOLTIPS.REHACER' | translate}}" igxButton="contained" igxRipple
                    [disabled]="!gridCompartirPresupuesto.transactions.canRedo" (buttonClick)="redo()">
              <igx-icon>redo</igx-icon>
            </button>
            <button title="{{ 'TOOLTIPS.GUARDAR' | translate}}" igxButton="contained" igxRipple
                    [disabled]="!hasTransactions" (buttonClick)="commit()">
              <igx-icon>save</igx-icon>
            </button>
            <button title="{{ 'TOOLTIPS.DESCARTAR' | translate}}" igxButton="contained" igxRipple
                    [disabled]="!hasTransactions" (buttonClick)="discard()">
              <igx-icon>clear</igx-icon>
            </button>
            <app-mas-opciones-grid #masOpciones [arrayDatosAVer]="[3, 6]"
                                   (opcionSeleccionada)="onSelectionDropDown($event, false)"/>
            <button #btnMenuCorreos igxButton="fab" igxRipple (buttonClick)="drawer.toggle()" style="margin-left: 1rem">
              <igx-icon family="material">menu</igx-icon>
            </button>
          </igx-grid-toolbar-actions>
        </igx-grid-toolbar>
        <ng-template igxSortHeaderIcon>
          <igx-icon>north</igx-icon>
        </ng-template>
        <ng-template igxSortAscendingHeaderIcon>
          <igx-icon>north</igx-icon>
        </ng-template>
        <ng-template igxSortDescendingHeaderIcon>
          <igx-icon>south</igx-icon>
        </ng-template>
        <ng-template igxExcelStyleHeaderIcon>
          <igx-icon>filter_alt</igx-icon>
        </ng-template>
        <igx-column field="EmailUsuarioCompartido" header="{{'GRIDS.COMPARTIR_PPTO.COL_CORREO' | translate}}"
                    [dataType]="'string'" width="320px" [sortable]="true" [resizable]="true" [cellStyles]="cellStyles"
                    [hasSummary]="true" [summaries]="'filasSummary' | summaryPipeNeo">
          <ng-template igxHeader let-column>
            <div title="{{'GRIDS.COMPARTIR_PPTO.COL_CORREO' | translate}}"
                 class="header-required">{{ column.header + '*' }}
            </div>
          </ng-template>
          <ng-template igxCellEditor let-cell="cell">
            <igx-input-group>
              <input igxInput name="EmailUsuarioCompartido" type="email" [igxFocus]="true" [igxTextSelection]="true"
                     [(ngModel)]="cell.editValue" maxLength="320"/>
            </igx-input-group>
          </ng-template>
        </igx-column>
        <igx-column field="NivelAccesoS" header="{{'GRIDS.COMPARTIR_PPTO.COL_NIVEL_ACCESO' | translate}}"
                    [dataType]="'string'" width="200px" [sortable]="true" [resizable]="true">
          <ng-template igxCellEditor let-cell="cell">
            <igx-select class="cell-select" [(ngModel)]="cell.editValue" [igxFocus]="true">
              @for (nivel of nivelAccesso; track nivel) {
                <igx-select-item [value]="nivel">
                  {{ nivel }}
                </igx-select-item>
              }
            </igx-select>
          </ng-template>
        </igx-column>
        <igx-column field="FechaVigencia" header="{{'GRIDS.COMPARTIR_PPTO.COL_FECHA_VIGENCIA' | translate}}"
                    [dataType]="'date'" width="180px" [sortable]="true" [resizable]="true">
          <ng-template igxCell let-val>
            {{ val | date: 'dd/MM/yyyy' }}
          </ng-template>
        </igx-column>
        <!--Acciones Editar, Agregar y Borrar-->
        @if (showActionStrip) {
          <igx-action-strip #actionstrip>
            <button title="{{ 'TOOLTIPS.EDITAR_REGISTRO' | translate}}" igxButton="fab" igxRipple style="margin-right: 5px"
                    (buttonClick)='startEdit(actionstrip.context)'>
              <igx-icon>edit</igx-icon>
            </button>
            <button title="{{'TOOLTIPS.BORRAR_USER_COMPARTIDO' | translate}}" igxButton="fab"
                    (buttonClick)="accionStripRowBtn(actionstrip.context, 2)">
              <igx-icon>delete</igx-icon>
            </button>
          </igx-action-strip>
        }
      </igx-grid>
    </div>
  </igx-card-content>
</igx-card>
